module.exports = __webpack_public_path__ + "static/media/sh.e26b4b82.svg";